const messages = {
  title: '¡Listo! Se ha generado tu preorden, pronto nos pondremos en contacto contigo vía WhatsApp',
  whatsAppText: 'Ir a WhatsApp',
  catalogueText: 'Regresar al catálogo',
};

export {
  messages,
};
